export const LOADING_BAR = 'LOADING_BAR'
export const ALERT = 'ALERT'
export const STORE_MOBILE_VERSION_ACTION = 'STORE_MOBILE_VERSION_ACTION'
export const STORE_LANGUAGE = 'STORE_LANGUAGE'
export const STORE_BRAND = 'STORE_BRAND'
